<script>
/**
 * One translated sentence with markup inside it.
 *
 * `t()` returns text, so a sentence with a `<b>` or a link in the middle would
 * have to be cut into pieces, and Japanese puts the pieces in another order.
 * This keeps the sentence whole: `k` is the English key (lib/i18n.js), and
 * each `{name}` in it is filled from the slot of that name, or else from
 * `params`.
 *
 *   <Phrase k="Each page is checked {samples} times.">
 *     <template #samples><b>{{ samples }}</b></template>
 *   </Phrase>
 *
 * Renders no element of its own unless `tag` is given.
 */
import { h } from 'vue'
import { t } from '../../lib/i18n.js'

export default {
  name: 'Phrase',
  props: {
    k: { type: String, required: true },
    params: { type: Object, default: null },
    tag: { type: String, default: null },
  },
  setup(props, { slots }) {
    return () => {
      const parts = t(props.k)
        .split(/(\{\w+\})/)
        .filter(Boolean)
        .map((part) => {
          const name = /^\{(\w+)\}$/.exec(part)?.[1]
          if (!name) return part
          if (slots[name]) return slots[name]()
          if (props.params && props.params[name] != null) return String(props.params[name])
          return part
        })
        .flat()
      return props.tag ? h(props.tag, parts) : parts
    }
  },
}
</script>
